import { render, staticRenderFns } from "./Reportar.vue?vue&type=template&id=69651cd6&"
import script from "./Reportar.vue?vue&type=script&lang=js&"
export * from "./Reportar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports